module.exports = __webpack_public_path__ + "static/media/smart-app.0dc8efe2.png";